/**
 *
 */
export class MissingParamError extends Error {
    constructor(paramName) {
        super(`Missing param: ${paramName}`);
        this.name = "MissingParamError";
    }
}

export class TypeParamError extends Error {
    constructor(paramName) {
        super(`Type param invalid: ${paramName}`);
        this.name = "TypeParamError";
    }
}

export class InvalidFileError extends Error {
    constructor() {
        super("Invalid file");
        this.name = "InvalidFileError";
    }
}

export class MonthNotFoundError extends Error {
    constructor(message) {
        super(message);
        this.name = "MonthNotFoundError";
    }
}

export class DocumentContentError extends Error {
    constructor(message) {
        super(message);
        this.name = "DocumentContentError";
    }
}

export class DocumentSystemError extends Error {
    constructor(message) {
        super(message);
        this.name = "DocumentSystemError";
    }
}
